import { useState } from "react";
import { T } from "react-translator-component";
import { Tooltip, Typography } from "@mui/material";
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from "../../common/colors";

interface Props {
  text: string,
  allowSelectingText?: boolean
}

export default function CopyText({ text, allowSelectingText }: Props) {
  const [showCopiedMessage, setShowCopiedMessage] = useState<boolean>(false);

  const copyToClipboard = async (text: string) => {
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      setShowCopiedMessage(true)

      setTimeout(() => setShowCopiedMessage(false), 1000);
    } catch (err) {
      console.error("Clipboard API not supported, using fallback:", err);
      return
    }
  }

  return (
    <Tooltip
      title={T("mng_copied_success")}
      open={showCopiedMessage}
      placement="bottom"
      PopperProps={{ disablePortal: true }}
    >
      <Typography
        onClick={() => copyToClipboard(text)}
        component={"span"}
        sx={allowSelectingText ? { userSelect: "text" } : {}}
      >
        {text}
        {text && <FontAwesomeIcon style={styles.copyIcon} icon={faCopy} />}
      </Typography>
    </Tooltip>
  );
}

const styles = {
  copyIcon: {
    marginLeft: "10px",
    color: colors.farm_blue200,
  },
}